import { render, staticRenderFns } from "./MacrosCategoryDelete.vue?vue&type=template&id=5c0788f2"
import script from "./MacrosCategoryDelete.vue?vue&type=script&lang=js"
export * from "./MacrosCategoryDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports